import React, { ReactElement } from 'react';

import { Svg } from '@pb/shared/ui/atoms/svg';
import { TIconProperties } from './icon.types';
import { StyledCircledIcon, StyledWrapper } from './icon.styled';
import { iconPaths } from './icon.paths';

/**
 * ### How to supply new icons
 * Instructions to follow.
 */
export function Icon({
    type,
    color = 'purple',
    circled = false,
    size = 24,
    accessibleTitle,
    ...otherProperties
}: TIconProperties): ReactElement | null {
    const svg = (
        <Svg
            color={color}
            width={size}
            height={size}
            testID={`${type}-icon`}
            accessibleTitle={accessibleTitle}
            {...otherProperties}
        >
            {(iconPaths as any)[type]}
        </Svg>
    );

    if (circled) {
        return (
            <StyledWrapper>
                <StyledCircledIcon
                    color={color}
                    circleSize={size + 8}
                    data-testid="circle"
                >
                    {svg}
                </StyledCircledIcon>
            </StyledWrapper>
        );
    }

    return svg;
}
